import React, { useEffect, useState, useRef } from 'react';
// import "./TopBar.css";
import { FiArrowLeft } from 'react-icons/fi';
import { MdOutlineGroupAdd, MdClear } from 'react-icons/md';
import EditPanel1 from 'src/components/_chats/staff/components/GroupEdit/Create';
import EditPanel2 from 'src/components/_chats/staff/components/GroupEdit/Create2';
import { useSelector } from 'src/redux/store';
// import Picture from "./Picture";
import moment from 'moment';
import useAuth from 'src/hooks/useAuth';
import { setPanel } from 'src/redux/slices/staff';
import { useDispatch } from 'react-redux';
import { fToNow } from 'src/utils/formatTime';
import NewChat from './components/NewChat';
import { Participantes } from './components/Participantes';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from 'src/@/components/ui/sheet';
import { Button } from 'src/@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from 'src/@/components/ui/avatar';

moment.locale('pt-br');

const ChatInternoHeaderDetail = ({ chat }) => {
    const dispatch = useDispatch();
    const { user } = useAuth();
    const { room, onlineUsers, panel, newGroupUsers } = useSelector((state) => state.staff);
    const [open, setOpen] = React.useState(false);

    let other = {};
    chat.people &&
        chat.people.forEach((person) => {
            if (user.id !== person._id) other = person;
        });

    if (!other.firstName) {
        other = { ...other, firstName: '', lastName: '' };
    }

    const title = (chat.isGroup ? chat.title : `${other.firstName} ${other.lastName}`).substr(0, 22);

    useEffect(() => {
        dispatch(setPanel('editGroup'));
    }, []);

    const Online = ({ other }) => {
        const prevStatusRef = useRef(false);
        const [lastOnline, setLastOnline] = useState(null);

        useEffect(() => {
            if (prevStatusRef.current && onlineUsers.filter((u) => u.id === other._id).length === 0)
                setLastOnline(moment().valueOf());
            prevStatusRef.current = onlineUsers.filter((u) => u.id === other._id).length > 0;
        }, [onlineUsers]);

        if (onlineUsers.filter((u) => u.id === other._id && u.status === 'busy').length > 0) return 'busy';
        if (onlineUsers.filter((u) => u.id === other._id && u.status === 'online').length > 0) return 'online';
        if (onlineUsers.filter((u) => u.id === other._id && u.status === 'away').length > 0) return 'away';
        if (lastOnline) return moment(lastOnline).format('dd/MM - h:mm A');

        return (
            <span className="text-[10px] text-gray-500 dark:text-[#ABABAD]">{`ultima vizualização: ${other.lastOnline ? fToNow(other.lastOnline) : ''
                }`}</span>
        );
    };

    const getStatus = () => {
        if (room) {
            if (room.isGroup) return null;
        }
        if (onlineUsers.filter((u) => u.id === other._id && u.status === 'busy').length > 0) return 'ocupado';
        if (onlineUsers.filter((u) => u.id === other._id && u.status === 'online').length > 0) return 'online';
        if (onlineUsers.filter((u) => u.id === other._id && u.status === 'away').length > 0) return 'away';
    };

    const getPanel = () => {
        switch (panel) {
            case 'editGroup':
                return <EditPanel1 set chat={chat} continueEdit={handleContinueEdit} />;
            case 'editGroup2':
                return <EditPanel2 chat={chat} />;
            default:
                return <EditPanel1 chat={chat} continueEdit={handleContinueEdit} />;
        }
    };

    const handleContinueEdit = (e) => {
        e.preventDefault();
        if (newGroupUsers.length > 1) dispatch(setPanel('editGroup2'));
    };

    return (
        <>
            <Sheet open={open} onOpenChange={setOpen}>
                <SheetContent className="w-[500px]">
                    <SheetHeader>
                        <SheetTitle className="flex items-center gap-2 text-gray-900">
                            <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => setOpen(false)}
                                className="h-9 w-9 rounded-lg hover:bg-gray-100 dark:hover:bg-[#2A2A2A] text-gray-400 dark:text-[#71717A] hover:text-gray-700 dark:hover:text-[#D1D2D3]"
                            >
                                <MdClear className="h-4 w-4" />
                            </Button>
                            Editar Grupo
                        </SheetTitle>
                    </SheetHeader>
                    {getPanel()}
                </SheetContent>
            </Sheet>

            <div className="flex items-center justify-between px-5 py-3 bg-white/80 dark:bg-[#1A1A1A]/80 backdrop-blur-xl border-b border-gray-200/60 dark:border-[#2A2A2A] sticky top-0 z-20 transition-all duration-200">
                <div className="flex items-center gap-3 overflow-hidden">
                    <div className="relative">
                        <Avatar className="h-9 w-9 border border-gray-100 dark:border-[#383838] shadow-sm">
                            <AvatarImage src={chat.isGroup ? chat.photo : other.photoURL} />
                            <AvatarFallback
                                className={`${chat.isGroup ? 'bg-violet-50 dark:bg-violet-500/10 text-violet-600 dark:text-violet-400' : 'bg-violet-50 dark:bg-violet-500/10 text-violet-600 dark:text-violet-400'
                                    } font-semibold text-xs`}
                            >
                                {chat.isGroup
                                    ? chat.title?.[0]?.toUpperCase() || '#'
                                    : other.firstName?.[0]?.toUpperCase() || '?'}
                            </AvatarFallback>
                        </Avatar>
                        {!chat.isGroup && getStatus() === 'online' && (
                            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 border-2 border-white dark:border-[#1A1A1A] rounded-full" />
                        )}
                        {!chat.isGroup && getStatus() === 'ocupado' && (
                            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-red-400 border-2 border-white dark:border-[#1A1A1A] rounded-full" />
                        )}
                        {!chat.isGroup && getStatus() === 'away' && (
                            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-amber-400 border-2 border-white dark:border-[#1A1A1A] rounded-full" />
                        )}
                    </div>
                    <div className="flex-1 min-w-0">
                        <h4 className="text-[13px] font-semibold text-gray-900 dark:text-[#E4E4E7] truncate leading-tight">{title}</h4>
                        <div className="text-[11px] text-gray-400 dark:text-[#71717A] font-medium flex items-center gap-1.5 mt-0.5 truncate">
                            {chat.isGroup ? <Participantes chat={chat} /> : <Online other={other} />}
                        </div>
                    </div>
                </div>
                {room && room.isGroup === true && (
                    <div className="pl-2">
                        <NewChat
                            onCallback={() => {
                                // dispatch(getChatInternoBuscarContatos(clienteId))
                            }}
                            isEdit
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default ChatInternoHeaderDetail;